module.exports = __webpack_public_path__ + "static/media/Maokai.d8cee56d.png";